import EventEmitter from 'events';

export default class Player extends EventEmitter {
	constructor(elemId) {
		super();

		this.elemId = elemId;
	}
}
